import React, { FC, useState } from 'react';
import withTranslate from '../../../common/components/with-translate/with-translate';
import { FeedType, HeaderTabsCommonProps } from './models';
import { MobileDrawer } from 'wix-ui-tpa/MobileDrawer';
import { ActionsMenuLayout } from 'wix-ui-tpa/ActionsMenuLayout';
import { connect } from '../../../common/components/runtime-context';
import { getAllCategories } from '../../../common/selectors/categories-selectors';
import styles from './header-tabs-mobile.scss';
import { flowRight, isString } from 'lodash';
import { RootState } from '../../reducers/root-state';
import ArrowDownRight from 'wix-ui-icons-common/ArrowDownRight';
import { ChevronUpDownIcon } from '../../components/icons/chevron-up-down-icon';
import classNames from 'classnames';
import { generateHeaderTabs } from './generate-header-tabs';
import { getActiveSelectorItem } from './store/header-tabs.selectors';

interface HeaderTabsMobileProps {
  categories: any[];
  onCategoryChange: (slug: string) => void;
  activeStateName: string;
  navigateToMainTab: (id: FeedType, feedType: FeedType | null) => void;
}

const HeaderTabsMobile: FC<HeaderTabsMobileProps & HeaderTabsCommonProps> = ({
  t,
  mainPageType,
  activeFeedType,
  categories,
  onCategoryChange,
  activeStateName,
  navigateToMainTab,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeDrawer = () => setIsOpen(false);
  const navigationItems = generateHeaderTabs({
    t,
    mainPageType,
    activeFeedType,
  });

  const activeItemName =
    navigationItems.find(x => x.id === activeStateName)?.title || activeStateName;

  return (
    <>
      <div
        className={styles.labelContainer}
        onClick={() => setIsOpen(true)}
        data-hook="header-tabs-select-trigger"
      >
        <span className={styles.label}>{activeItemName}</span>
        <ChevronUpDownIcon className={classNames(['forum-icon-fill', styles.labelIcon])} />
      </div>
      <div>
        <MobileDrawer isOpen={isOpen} onRequestClose={closeDrawer}>
          <ActionsMenuLayout className={styles.drawerContainer} data-hook="header-tabs-actions">
            {navigationItems.map(navigationItem => (
              <ActionsMenuLayout.Item
                key={navigationItem.feedType}
                onClick={() => {
                  navigateToMainTab(navigationItem.id, navigationItem.feedType);
                  closeDrawer();
                }}
                content={navigationItem.title}
              />
            ))}
            <ActionsMenuLayout.Divider />
            {categories.map(category => (
              <ActionsMenuLayout.Item
                key={category._id}
                onClick={() => {
                  onCategoryChange(category.slug);
                  closeDrawer();
                }}
                content={category.label}
                prefixIcon={isString(category.parentId) ? <ArrowDownRight /> : undefined}
              />
            ))}
          </ActionsMenuLayout>
        </MobileDrawer>
      </div>
    </>
  );
};

const mapRuntimeToProps = (state: RootState, ownProps: any, actions: any) => {
  return {
    categories: getAllCategories(state),
    activeStateName: getActiveSelectorItem(state, ownProps.mainPageType),
    onCategoryChange: (slug: string) => actions.navigateWithinForum(`/${slug}`),
    navigateToMainTab: (id: FeedType, feedType: FeedType | null) =>
      actions.navigateToMainTab(id, feedType),
  };
};

export default flowRight(connect(mapRuntimeToProps), withTranslate)(HeaderTabsMobile);
